"use client";

import React, { useState, useEffect, useRef, useCallback } from "react";
import { motion, AnimatePresence, MotionConfig, useReducedMotion } from "framer-motion";
import { Instagram, Facebook, Linkedin, ChevronLeft, ChevronRight, X } from "lucide-react";
import TextReveal from "./animations/TextReveal";

/* ───────────────────────── DATA (unchanged) ───────────────────────── */
const teamMembers = {
  "2026": [
    { id: 1, firstName: "Emna", lastName: "Megdiche", position: "Chair", image: "/asset/team/emnamegdiche.png", social: { instagram: "https://www.instagram.com/emna_megdiche3/", facebook: "https://www.facebook.com/mannou.megdiche", linkedin: "https://www.linkedin.com/in/emna-megdiche-1997b225a/", email: "emna@example.com" } },
    { id: 2, firstName: "Aziz", lastName: "Alimi", position: "Vice-Chair", image: "/asset/team/alimi2.png", social: { instagram: "https://www.instagram.com/azizalimi_/", facebook: "https://www.facebook.com/aziz.alimi.3", linkedin: "https://www.linkedin.com/in/aziz-alimi-3717a333a/", email: "aziz@example.com" } },
    { id: 3, firstName: "Yosra", lastName: "Teieb", position: "Membership Coordinator", image: "/asset/team/yosrateieb.png", social: { instagram: "https://www.instagram.com/yosra._.teieb/", facebook: "https://www.facebook.com/yosra.teieb.2025", linkedin: "https://www.linkedin.com/in/yosra-teieb/", email: "yosra@example.com" } },
    { id: 4, firstName: "Fedi", lastName: "Triki", position: "Project Manager", image: "/asset/team/feditriki.png", social: { instagram: "https://www.instagram.com/trikifedi7/", facebook: "https://www.facebook.com/fedi.triki.121", linkedin: "https://www.linkedin.com/in/fedi-triki/", email: "fedi@example.com" } },
    { id: 5, firstName: "AbdelKader", lastName: "Barkia", position: "Treasurer", image: "/asset/team/gaddour.png", social: { instagram: "https://www.instagram.com/abdelkader_barkia/", facebook: "https://www.facebook.com/abdelkader.barkia.2025", linkedin: "https://www.linkedin.com/in/abdelkader-barkia-0312b3357/", email: "abdelkader@example.com" } },
    { id: 7, firstName: "Roua", lastName: "Zouawi", position: "Secretary", image: "/asset/team/rourou.png", social: { instagram: "https://www.instagram.com/roua__zouawi/", facebook: "https://www.facebook.com/spamm.pikaa", linkedin: "https://www.linkedin.com/in/roua-zouawi-b256bb275/", email: "roua@example.com" } },
    { id: 6, firstName: "Mohamed", lastName: "Tounsi", position: "WebMaster", image: "/asset/team/rougeieee.png", social: { instagram: "https://www.instagram.com/mohamed__tounsii/", facebook: "https://www.facebook.com/mohamed.tounsi.583", linkedin: "https://www.linkedin.com/in/mohamed-tounsi-541439351/", email: "mohamed@example.com" } },
    { id: 6, firstName: "Amal", lastName: "Cherif", position: "Members Cordinator", image: "/asset/team/amal.png", social: { instagram: "https://www.instagram.com/cherif_amall/", facebook: "https://www.facebook.com/amal.cherif.334585", linkedin: "#", email: "mohamed@example.com" } },
    { id: 9, firstName: "Ilhem", lastName: "Kallel", position: "Counselor", image: "/asset/team/mrsilhem.webp", social: { instagram: "https://www.instagram.com/ilhem_kallel/", facebook: "https://www.facebook.com/ikallel", linkedin: "https://www.linkedin.com/in/ilhem-kallel-78699b36/", email: "ilhem@example.com" } },
  ],
  "2025": [
    { id: 1, firstName: "Emna", lastName: "Awadni", position: "Chair", image: "/asset/team/emnaaw.webp", social: { instagram: "https://www.instagram.com/emnaawadni/", facebook: "https://www.facebook.com/emna.awadni", linkedin: "https://www.linkedin.com/in/emna-awadni-a50b692b1/", email: "emna@example.com" } },
    { id: 2, firstName: "Yassine", lastName: "Kaffel", position: "Vice-Chair", image: "/asset/team/kaffel.png", social: { instagram: "https://www.instagram.com/yassine_kaffel/", facebook: "https://www.facebook.com/Yassine.kaffel65", linkedin: "https://www.linkedin.com/in/kaffel-yassine-849b7b2b9/", email: "aziz@example.com" } },
    { id: 3, firstName: "Emna", lastName: "Megdiche", position: "HR Manager", image: "/asset/team/emnamag.png", social: { instagram: "https://www.instagram.com/emna_megdiche3/", facebook: "https://www.facebook.com/mannou.megdiche", linkedin: "https://www.linkedin.com/in/emna-megdiche-1997b225a/", email: "yosra@example.com" } },
    { id: 4, firstName: "Med Aziz", lastName: "Mesfar", position: "Tech Project Manager", image: "/asset/team/aziz2.png", social: { instagram: "https://www.instagram.com/med_aziz_mesfar/", facebook: "https://www.facebook.com/medaziz.mesfar", linkedin: "https://www.linkedin.com/in/med-aziz-mesfar-a16b092a0/", email: "fedi@example.com" } },
    { id: 10, firstName: "Anja", lastName: "Ncib", position: "Non-Tech Project Manager", image: "/asset/team/anja.png", social: { instagram: "https://www.instagram.com/anja_nc/", facebook: "https://www.facebook.com/ncib.anjouja", linkedin: "https://www.linkedin.com/in/anja-ncib/", email: "fedi@example.com" } },
    { id: 5, firstName: "Salmen", lastName: "Khabou", position: "Treasurer", image: "/asset/team/salmen.png", social: { instagram: "https://www.instagram.com/salmen_khabou/", facebook: "https://www.facebook.com/salmenkhabou.kh7", linkedin: "https://www.linkedin.com/in/khabou-salmen-287b441b5/", email: "abdelkader@example.com" } },
    { id: 7, firstName: "Nour", lastName: "Ajili", position: "Secretary", image: "/asset/team/nouraj.png", social: { instagram: "https://www.instagram.com/nourajili12/", facebook: "https://www.facebook.com/nour.ajili.7", linkedin: "https://linkedin.com/in/nour_ajili", email: "roua@example.com" } },
    { id: 8, firstName: "Elee", lastName: "Abidi", position: "Media Manager", image: "/asset/team/elee1.png", social: { instagram: "https://www.instagram.com/elee__abidi/", facebook: "https://www.facebook.com/elee.abidi.7", linkedin: "https://www.linkedin.com/in/elee-abidi-68ab8432a/", email: "elee@example.com" } },
    { id: 6, firstName: "Med Amin", lastName: "Mallek", position: "WebMaster", image: "/asset/team/amin.png", social: { instagram: "https://www.instagram.com/mallekamin30/", facebook: "https://www.facebook.com/amin.mallek.3", linkedin: "https://www.linkedin.com/in/amin-mallek-a45aaa285/", email: "mohamed@example.com" } },
    { id: 9, firstName: "Ilhem", lastName: "Kallel", position: "Counselor", image: "/asset/team/mrsilhem.webp", social: { instagram: "https://www.instagram.com/ilhem_kallel/", facebook: "https://www.facebook.com/ikallel", linkedin: "https://www.linkedin.com/in/ilhem-kallel-78699b36/", email: "ilhem@example.com" } },
  ],
  "2024": [
    { id: 1, firstName: "Eya", lastName: "Chaaben", position: "Chair", image: "/asset/team/eya2024.png", social: { instagram: "https://www.instagram.com/eyaa_chaaben", facebook: "https://www.facebook.com/Eyaa.Chaabene", linkedin: "https://www.linkedin.com/in/eya-chaabene-b33369278", email: "emna@example.com" } },
    { id: 2, firstName: "Anis", lastName: "Charfi", position: "Vice-Chair", image: "/asset/team/anis.jpg", social: { instagram: "https://www.instagram.com/anis_charfi", facebook: "https://www.facebook.com/search/top?q=anis%20charfi", linkedin: "https://www.linkedin.com/in/anis-charfi-aa39b2218", email: "aziz@example.com" } },
    { id: 5, firstName: "Yassine", lastName: "Kaffel", position: "Treasurer", image: "/asset/team/kaffel.png", social: { instagram: "https://www.instagram.com/yassine_kaffel/", facebook: "https://www.facebook.com/Yassine.kaffel65", linkedin: "https://www.linkedin.com/in/kaffel-yassine-849b7b2b9/", email: "abdelkader@example.com" } },
    { id: 7, firstName: "Emna", lastName: "Awadni", position: "Secretary", image: "/asset/team/emnaaw.png", social: { instagram: "https://www.instagram.com/emnaawadni/", facebook: "https://www.facebook.com/emna.awadni", linkedin: "https://www.linkedin.com/in/emna-awadni-a50b692b1/", email: "roua@example.com" } },
    { id: 6, firstName: "Aya", lastName: "Aidi", position: "WebMaster", image: "/asset/team/none.webp", social: { instagram: "https://www.instagram.com/aya.aidi.96", facebook: "https://www.facebook.com/aya.aidi.96", linkedin: "https://www.linkedin.com/in/aya-aidi-b105ab2a2", email: "mohamed@example.com" } },
    { id: 9, firstName: "Ilhem", lastName: "Kallel", position: "Counselor", image: "/asset/team/mrsilhem.webp", social: { instagram: "https://www.instagram.com/ilhem_kallel/", facebook: "https://www.facebook.com/ikallel", linkedin: "https://www.linkedin.com/in/ilhem-kallel-78699b36/", email: "ilhem@example.com" } },
  ],
  "2023": [
    { id: 1, firstName: "Emna", lastName: "Sahnoun", position: "Chair", image: "/asset/team/sahnoun.jpg", social: { instagram: "https://www.instagram.com/emna_sahnoun_", facebook: "https://www.facebook.com/emna.sahnoun.56", linkedin: "https://www.linkedin.com/in/emna-sahnoun-2816aa202", email: "emna@example.com" } },
    { id: 2, firstName: "Karim", lastName: "Guermazi", position: "Vice-Chair", image: "/asset/team/karim.jpg", social: { instagram: "https://www.instagram.com/karim.guermazi", facebook: "https://www.facebook.com/karim.guermazi.3", linkedin: "https://www.linkedin.com/in/karim-guermazi-0b538518b", email: "aziz@example.com" } },
    { id: 5, firstName: "Mariem", lastName: "Mnif", position: "Treasurer", image: "/asset/team/mnif.jpg", social: { instagram: "https://www.instagram.com/mariem_mnif_3", facebook: "https://www.facebook.com/mariem.mnif.2025", linkedin: "https://www.linkedin.com/in/mariem-mnif-579034231", email: "abdelkader@example.com" } },
    { id: 7, firstName: "Eya", lastName: "Guirat", position: "Secretary", image: "/asset/team/guirat.jpg", social: { instagram: "https://www.instagram.com/eya.guirat", facebook: "https://www.facebook.com/eya.guirat.2025", linkedin: "https://www.linkedin.com/in/eya-guirat-67594b22a", email: "roua@example.com" } },
    { id: 6, firstName: "Baha eddine", lastName: "Chalbia", position: "WebMaster", image: "/asset/team/baha.jpg", social: { instagram: "https://www.instagram.com/bahachoi", facebook: "https://www.facebook.com/baha.chalbia.4", linkedin: "https://www.linkedin.com/in/baha-eddine-chalbia", email: "mohamed@example.com" } },
    { id: 9, firstName: "Ilhem", lastName: "Kallel", position: "Counselor", image: "/asset/team/mrsilhem.webp", social: { instagram: "https://www.instagram.com/ilhem_kallel/", facebook: "https://www.facebook.com/ikallel", linkedin: "https://www.linkedin.com/in/ilhem-kallel-78699b36/", email: "ilhem@example.com" } },
  ],
};

const years = ["2026", "2025", "2024", "2023"];
const pad = (n) => String(n).padStart(2, "0");
const EASE = [0.16, 1, 0.3, 1];

const networks = [
  ["instagram", "Instagram", Instagram],
  ["facebook", "Facebook", Facebook],
  ["linkedin", "LinkedIn", Linkedin],
];

const list = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.07 } },
};
const item = {
  hidden: { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: EASE } },
};

/* shared: blueprint grid that shows through transparent cut-out photos */
const Grid = () => (
  <div
    className="absolute inset-0 opacity-[0.12] pointer-events-none"
    style={{
      backgroundImage:
        "linear-gradient(#7cc4e8 1px, transparent 1px), linear-gradient(90deg, #7cc4e8 1px, transparent 1px)",
      backgroundSize: "28px 28px",
    }}
  />
);

/* icon-only social buttons (no text labels) */
function Socials({ member, size = "w-10 h-10", className = "" }) {
  const full = `${member.firstName} ${member.lastName}`;
  return (
    <div className={`flex items-center gap-2 pointer-events-auto ${className}`}>
      {networks.map(([key, label, Icon]) =>
        member.social[key] && member.social[key] !== "#" ? (
          <a
            key={key}
            href={member.social[key]}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${full} on ${label}`}
            onClick={(e) => e.stopPropagation()}
            className={`${size} flex items-center justify-center bg-white/10 text-white border border-white/25 hover:bg-white hover:text-[#00334d] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#7dd3fc]`}
          >
            <Icon className="w-[15px] h-[15px] sm:w-4 sm:h-4" strokeWidth={1.8} />
          </a>
        ) : null
      )}
    </div>
  );
}

/* ───────────── Member card ───────────── */
function Card({ member, index, onOpen }) {
  const full = `${member.firstName} ${member.lastName}`;
  return (
    <motion.article
      variants={item}
      className="group relative transition-transform duration-500 ease-out hover:-translate-y-2 focus-within:-translate-y-2"
    >
      {/* offset frame that slides out behind the card on hover */}
      <span className="absolute inset-0 border-2 border-[#006699] opacity-0 transition-all duration-500 ease-out group-hover:opacity-100 group-hover:translate-x-2.5 group-hover:translate-y-2.5 group-focus-within:opacity-100 group-focus-within:translate-x-2.5 group-focus-within:translate-y-2.5 pointer-events-none" />

      {/* taller on phone so the photo has room */}
      <div className="relative bg-[#00334d] aspect-[3/4.5] sm:aspect-[3/4] overflow-hidden focus-within:ring-2 focus-within:ring-[#7dd3fc]">
        {/* grid brightens on hover */}
        <div
          className="absolute inset-0 opacity-[0.12] group-hover:opacity-[0.3] transition-opacity duration-700 pointer-events-none"
          style={{
            backgroundImage:
              "linear-gradient(#7cc4e8 1px, transparent 1px), linear-gradient(90deg, #7cc4e8 1px, transparent 1px)",
            backgroundSize: "28px 28px",
          }}
        />
        <img
          src={member.image}
          alt={full}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover object-top transition-all duration-[900ms] ease-out group-hover:scale-[1.08] group-hover:-translate-y-1"
        />

        {/* shade behind the text */}
        <div className="absolute inset-x-0 bottom-0 h-[55%] sm:h-1/2 bg-gradient-to-t from-[#00334d]/95 via-[#00334d]/50 to-transparent pointer-events-none" />

        {/* light sweep on hover */}
        <span className="absolute inset-y-0 -left-1/2 w-1/3 -skew-x-12 bg-gradient-to-r from-transparent via-white/35 to-transparent pointer-events-none z-10 group-hover:translate-x-[520%] group-hover:transition-transform group-hover:duration-[1000ms] group-hover:ease-out" />

        {/* corner brackets draw in */}
        <span className="absolute top-3 left-3 w-0 h-0 border-t-2 border-l-2 border-[#7dd3fc] opacity-0 group-hover:opacity-100 group-hover:w-8 group-hover:h-8 transition-all duration-500 pointer-events-none z-10" />
        <span className="absolute bottom-3 right-3 w-0 h-0 border-b-2 border-r-2 border-[#7dd3fc] opacity-0 group-hover:opacity-100 group-hover:w-8 group-hover:h-8 transition-all duration-500 pointer-events-none z-10" />

        {/* outlined index fills in on hover */}
        <span
          className="absolute top-2 right-2.5 sm:top-3 sm:right-4 text-4xl sm:text-7xl font-black leading-none tracking-tighter text-transparent group-hover:text-[#7dd3fc] tabular-nums select-none pointer-events-none transition-colors duration-500 z-10"
          style={{ WebkitTextStroke: "1.2px rgba(255,255,255,0.8)" }}
          aria-hidden="true"
        >
          {pad(index + 1)}
        </span>

        {/* click target for the whole card */}
        <button
          onClick={onOpen}
          aria-label={`Open ${full}, ${member.position}`}
          className="absolute inset-0 z-[15] cursor-pointer focus:outline-none"
        />

        {/* name plate (clicks pass through to the button, except the social icons) */}
        <div className="absolute inset-x-0 bottom-0 p-3 sm:p-6 z-20 pointer-events-none">
          <span className="inline-block bg-[#7dd3fc] group-hover:bg-white text-[#00334d] text-[9px] leading-tight sm:text-sm font-bold px-2 py-0.5 sm:px-3 sm:py-1 mb-2 sm:mb-3 transition-colors duration-300">
            {member.position}
          </span>
          <p className="text-[11px] sm:text-lg font-light text-white/90 leading-none [text-shadow:0_1px_8px_rgba(0,0,0,0.5)] transition-transform duration-500 group-hover:translate-x-1">
            {member.firstName}
          </p>
          <h3 className="mt-0.5 text-[17px] sm:text-3xl font-black text-white tracking-tight leading-tight break-words [text-shadow:0_1px_10px_rgba(0,0,0,0.5)] transition-transform duration-500 delay-75 group-hover:translate-x-1">
            {member.lastName}
          </h3>

          <div className="grid grid-rows-[0fr] group-hover:grid-rows-[1fr] group-focus-within:grid-rows-[1fr] [@media(hover:none)]:grid-rows-[1fr] transition-[grid-template-rows] duration-500 ease-out">
            <div className="overflow-hidden">
              <Socials member={member} size="w-8 h-8 sm:w-10 sm:h-10" className="pt-2.5 sm:pt-4 gap-1.5 sm:gap-2" />
            </div>
          </div>
        </div>
      </div>
    </motion.article>
  );
}

/* ───────────── Counselor: one wide card, as long as a full row, photo on the right ───────────── */
function WideCard({ member, index, onOpen }) {
  const full = `${member.firstName} ${member.lastName}`;
  return (
    <motion.article
      variants={item}
      className="group relative transition-transform duration-500 ease-out hover:-translate-y-2 focus-within:-translate-y-2"
    >
      <span className="absolute inset-0 border-2 border-[#006699] opacity-0 transition-all duration-500 ease-out group-hover:opacity-100 group-hover:translate-x-2.5 group-hover:translate-y-2.5 group-focus-within:opacity-100 group-focus-within:translate-x-2.5 group-focus-within:translate-y-2.5 pointer-events-none" />

      <div className="relative h-[300px] sm:h-[340px] lg:h-auto grid grid-cols-1 lg:grid-cols-12 bg-[#00334d] overflow-hidden focus-within:ring-2 focus-within:ring-[#7dd3fc]">
        <div
          className="absolute inset-0 opacity-[0.12] group-hover:opacity-[0.3] transition-opacity duration-700 pointer-events-none"
          style={{
            backgroundImage:
              "linear-gradient(#7cc4e8 1px, transparent 1px), linear-gradient(90deg, #7cc4e8 1px, transparent 1px)",
            backgroundSize: "28px 28px",
          }}
        />

        {/* text side */}
        <div className="absolute inset-x-0 bottom-0 z-20 pointer-events-none lg:pointer-events-auto lg:relative lg:col-span-7 lg:order-1 p-4 sm:p-6 lg:p-14 flex flex-col justify-end lg:justify-between gap-3 lg:gap-8 lg:min-h-[480px] overflow-hidden">
          <span
            className="hidden lg:block absolute -bottom-8 -left-2 text-[320px] leading-none font-black tracking-tighter text-transparent tabular-nums select-none pointer-events-none"
            style={{ WebkitTextStroke: "1.5px rgba(124,196,232,0.22)" }}
            aria-hidden="true"
          >
            {pad(index + 1)}
          </span>

          <span className="relative self-start inline-block bg-[#7dd3fc] group-hover:bg-white text-[#00334d] text-[10px] sm:text-sm lg:text-base font-bold px-2.5 sm:px-3 lg:px-4 py-0.5 sm:py-1 lg:py-1.5 transition-colors duration-300">
            {member.position}
          </span>

          <div className="relative">
            <p className="text-sm sm:text-2xl lg:text-4xl font-light text-white/90 leading-none [text-shadow:0_1px_8px_rgba(0,0,0,0.5)] transition-transform duration-500 group-hover:translate-x-2">
              {member.firstName}
            </p>
            <h3 className="mt-1 lg:mt-2 text-3xl sm:text-5xl lg:text-8xl font-black text-white tracking-tighter leading-[0.95] [text-shadow:0_1px_10px_rgba(0,0,0,0.5)] transition-transform duration-500 delay-75 group-hover:translate-x-2">
              {member.lastName}
            </h3>
            <div className="hidden sm:flex mt-5 items-center gap-3">
              <span className="h-[3px] w-10 bg-[#7dd3fc]" />
              <p className="text-xs sm:text-base font-semibold text-[#7dd3fc]">IEEE ISIMS Student Branch</p>
            </div>
            <Socials member={member} size="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12" className="mt-3 lg:mt-7 relative z-20 gap-1.5 sm:gap-2" />
          </div>
        </div>

        {/* photo side (right) */}
        <div className="absolute inset-0 lg:relative lg:col-span-5 lg:order-2 lg:h-auto overflow-hidden">
          <img
            src={member.image}
            alt={full}
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover object-top transition-all duration-[1200ms] ease-out group-hover:scale-[1.06]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#00334d]/95 via-[#00334d]/25 to-transparent lg:bg-gradient-to-r lg:from-[#00334d]/60 lg:via-transparent lg:to-transparent pointer-events-none" />
          <span className="absolute inset-y-0 -left-1/2 w-1/3 -skew-x-12 bg-gradient-to-r from-transparent via-white/35 to-transparent pointer-events-none z-10 group-hover:translate-x-[520%] group-hover:transition-transform group-hover:duration-[1000ms] group-hover:ease-out" />
          <span
            className="absolute top-3 right-4 text-4xl sm:text-6xl lg:text-8xl font-black leading-none tracking-tighter text-transparent group-hover:text-[#7dd3fc] tabular-nums select-none pointer-events-none transition-colors duration-500 z-10"
            style={{ WebkitTextStroke: "1.5px rgba(255,255,255,0.8)" }}
            aria-hidden="true"
          >
            {pad(index + 1)}
          </span>
        </div>

        <span className="absolute top-4 left-4 w-8 h-8 border-t-2 border-l-2 border-[#7dd3fc] opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none z-20" />
        <span className="absolute bottom-4 right-4 w-8 h-8 border-b-2 border-r-2 border-[#7dd3fc] opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none z-20" />

        {/* click target for the whole card; the social icons stay above it */}
        <button
          onClick={onOpen}
          aria-label={`Open ${full}, ${member.position}`}
          className="absolute inset-0 z-[15] cursor-pointer focus:outline-none"
        />
      </div>
    </motion.article>
  );
}

/* ───────────── Modal ─────────────
   Fixed to the screen, nothing scrolls.
   Phone: the photo fills the whole card, name + role overlay at the bottom, 3 icons under them.
   Desktop: photo left, details right (icons only). */
function TeamModal({ member, index, total, year, onClose, onPrev, onNext }) {
  const reduce = useReducedMotion();
  const closeRef = useRef(null);
  const full = `${member.firstName} ${member.lastName}`;

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onNext();
      if (e.key === "ArrowLeft") onPrev();
    };
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    closeRef.current?.focus();
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose, onNext, onPrev]);

  const swipe = (_, info) => {
    if (info.offset.x < -60) onNext();
    else if (info.offset.x > 60) onPrev();
  };

  const navBtn =
    "w-11 h-11 bg-white/10 hover:bg-white/25 text-white border border-white/30 flex items-center justify-center transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white";

  return (
    <motion.div
      role="dialog"
      aria-modal="true"
      aria-label={full}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      className="fixed inset-0 z-50 bg-gray-900/70 backdrop-blur-sm flex items-center justify-center p-3 sm:p-6 lg:px-24 lg:py-8 overscroll-none touch-none lg:touch-auto"
      onClick={onClose}
    >
      <button ref={closeRef} onClick={onClose} aria-label="Close" className={`${navBtn} absolute top-3 right-3 sm:top-6 sm:right-6 z-20`}>
        <X className="w-5 h-5" />
      </button>
      <button
        onClick={(e) => { e.stopPropagation(); onPrev(); }}
        aria-label="Previous member"
        className={`${navBtn} hidden lg:flex absolute left-6 top-1/2 -translate-y-1/2 z-20`}
      >
        <ChevronLeft className="w-5 h-5" />
      </button>
      <button
        onClick={(e) => { e.stopPropagation(); onNext(); }}
        aria-label="Next member"
        className={`${navBtn} hidden lg:flex absolute right-6 top-1/2 -translate-y-1/2 z-20`}
      >
        <ChevronRight className="w-5 h-5" />
      </button>

      <div
        className="relative w-full max-w-6xl h-[calc(100dvh-6rem)] sm:h-[calc(100dvh-7rem)] lg:h-[min(78vh,700px)] mt-12 sm:mt-6 lg:mt-0 bg-white shadow-[0_30px_80px_rgba(0,0,0,0.5)] flex flex-col lg:flex-row overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* ── photo (full height on phone) ── */}
        <div className="relative bg-[#00334d] overflow-hidden flex-1 min-h-0 lg:flex-none lg:h-full lg:w-[44%]">
          <Grid />
          {/* ghost year (desktop only, phone keeps the photo clean) */}
          <span
            className="hidden lg:block absolute -bottom-3 -left-2 text-[200px] leading-none font-black tracking-tighter text-transparent select-none pointer-events-none"
            style={{ WebkitTextStroke: "1.5px rgba(124,196,232,0.3)" }}
            aria-hidden="true"
          >
            {year}
          </span>

          <AnimatePresence mode="wait">
            <motion.div
              key={`${year}-${index}`}
              initial={reduce ? false : { opacity: 0, scale: 1.04 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.35 }}
              drag="x"
              dragConstraints={{ left: 0, right: 0 }}
              dragElastic={0.25}
              onDragEnd={swipe}
              style={{ touchAction: "pan-y" }}
              className="absolute inset-0"
            >
              <img src={member.image} alt={full} draggable={false} className="w-full h-full object-cover object-top" />
            </motion.div>
          </AnimatePresence>

          {/* phone: dark fade so the overlay text stays readable */}
          <div className="lg:hidden absolute inset-x-0 bottom-0 h-[48%] bg-gradient-to-t from-[#00334d] via-[#00334d]/70 to-transparent pointer-events-none z-[5]" />

          <span className="absolute top-3 left-3 w-8 h-8 border-t-2 border-l-2 border-[#7cc4e8] z-10 pointer-events-none" />
          <span className="hidden lg:block absolute bottom-3 right-3 w-8 h-8 border-b-2 border-r-2 border-[#7cc4e8] z-10 pointer-events-none" />

          {/* phone: counter pill */}
          <span className="lg:hidden absolute top-3 left-14 z-10 bg-[#00334d]/80 text-white text-[11px] font-semibold px-2.5 py-1 tabular-nums pointer-events-none">
            {index + 1} / {total}
          </span>

          {/* phone arrows on the photo */}
          <button onClick={onPrev} aria-label="Previous member" className="lg:hidden absolute left-2 top-[38%] -translate-y-1/2 z-20 w-9 h-9 bg-[#00334d]/70 text-white border border-white/20 flex items-center justify-center active:bg-[#006699]">
            <ChevronLeft className="w-4 h-4" />
          </button>
          <button onClick={onNext} aria-label="Next member" className="lg:hidden absolute right-2 top-[38%] -translate-y-1/2 z-20 w-9 h-9 bg-[#00334d]/70 text-white border border-white/20 flex items-center justify-center active:bg-[#006699]">
            <ChevronRight className="w-4 h-4" />
          </button>

          {/* phone: name + role overlay on the photo, 3 icons right under */}
          <AnimatePresence mode="wait">
            <motion.div
              key={`ov-${year}-${index}`}
              initial={reduce ? false : { opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="lg:hidden absolute inset-x-0 bottom-0 z-10 p-5 pb-6 pointer-events-none"
            >
              <span className="inline-block bg-[#7dd3fc] text-[#00334d] text-[11px] font-bold px-2.5 py-1 mb-3">
                {member.position}
              </span>
              <p className="text-lg font-light text-white/90 leading-none [text-shadow:0_1px_8px_rgba(0,0,0,0.5)]">
                {member.firstName}
              </p>
              <h2 className="mt-1 text-4xl font-black text-white tracking-tighter leading-[0.95] break-words [text-shadow:0_1px_10px_rgba(0,0,0,0.5)]">
                {member.lastName}
              </h2>
              <Socials member={member} size="w-11 h-11" className="mt-4 gap-2.5" />
            </motion.div>
          </AnimatePresence>
        </div>

        {/* ── details (desktop only) ── */}
        <div className="hidden lg:flex flex-col flex-1 min-h-0 bg-[#fafcff] border-l border-[#006699]/10">
          <div className="relative flex-1 min-h-0 overflow-y-auto overscroll-contain p-12">
            <AnimatePresence mode="wait">
              <motion.div
                key={`${year}-${index}`}
                initial={reduce ? false : { opacity: 0, x: 16 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
              >
                <div className="flex items-end gap-4">
                  <span
                    className="text-[150px] leading-[0.78] font-black tracking-tighter text-transparent tabular-nums select-none"
                    style={{ WebkitTextStroke: "2px #006699" }}
                    aria-hidden="true"
                  >
                    {pad(index + 1)}
                  </span>
                  <span className="mb-1 inline-block bg-[#00334d] text-[#7dd3fc] text-sm font-bold px-3 py-1.5">
                    {member.position}
                  </span>
                </div>

                <div className="mt-8">
                  <p className="text-3xl font-light text-[#00334d]/70 leading-none">{member.firstName}</p>
                  <h2 className="mt-1 text-7xl font-black text-[#00334d] tracking-tighter leading-[0.95] break-words">
                    {member.lastName}
                  </h2>
                </div>

                <div className="mt-6 flex items-center gap-3">
                  <span className="h-[3px] w-10 bg-[#006699]" />
                  <p className="text-sm font-semibold text-[#006699]">Executive committee {year}</p>
                </div>
                <p className="mt-1 text-sm text-slate-500">IEEE ISIMS Student Branch</p>

                {/* icons only, no labels */}
                <div className="mt-8 flex gap-2.5">
                  {networks.map(([key, label, Icon]) =>
                    member.social[key] && member.social[key] !== "#" ? (
                      <a
                        key={key}
                        href={member.social[key]}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`${full} on ${label}`}
                        className="w-12 h-12 flex items-center justify-center bg-white text-[#006699] border border-[#006699]/25 hover:bg-[#006699] hover:text-white hover:border-[#006699] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#006699] focus-visible:ring-offset-2"
                      >
                        <Icon className="w-5 h-5" strokeWidth={2} />
                      </a>
                    ) : null
                  )}
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="flex-shrink-0 flex items-center justify-between px-12 py-3.5 border-t border-[#006699]/10 bg-white">
            <span className="text-xs font-semibold text-[#00334d]/60 tabular-nums">
              {index + 1} of {total}
            </span>
            <span className="text-xs font-semibold text-[#00334d]/40">Use the arrows</span>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default function Team() {
  const [selectedYear, setSelectedYear] = useState("2026");
  const members = teamMembers[selectedYear];
  const [openIndex, setOpenIndex] = useState(null);
  const close = useCallback(() => setOpenIndex(null), []);
  const onPrev = useCallback(() => setOpenIndex((i) => (i - 1 + members.length) % members.length), [members.length]);
  const onNext = useCallback(() => setOpenIndex((i) => (i + 1) % members.length), [members.length]);

  return (
    <MotionConfig reducedMotion="user">
      <section id="team" className="relative w-full bg-[#f4f7f9] py-14 md:py-24 lg:py-28 overflow-hidden">
        <div
          className="absolute inset-0 pointer-events-none opacity-60"
          style={{
            backgroundImage: `
              repeating-linear-gradient(-45deg, rgba(15,105,157,0.035) 0px, rgba(15,105,157,0.035) 1px, transparent 1px, transparent 18px),
              repeating-linear-gradient(45deg, rgba(15,105,157,0.025) 0px, rgba(15,105,157,0.025) 1px, transparent 1px, transparent 28px)
            `,
          }}
        />

        {/* tighter side padding on phone = wider cards */}
        <div className="relative max-w-[1500px] mx-auto px-3 sm:px-10 z-10">
          {/* header */}
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 md:gap-8 mb-8 md:mb-14 px-1 sm:px-0">
            <div className="flex items-end gap-4 sm:gap-5">
              
              <div className="pb-1">
                <TextReveal
                  as="h2"
                  className="text-sm font-semibold text-[#006699] mb-1 border-l-[3px] border-[#006699] pl-3"
                >
                  Leadership team
                </TextReveal>
                <TextReveal
                  as="h3"
                  className="text-2xl md:text-5xl font-black text-[#00334d] leading-tight tracking-tight"
                  stagger={0.05}
                >
                  Meet our executive committee
                </TextReveal>
              </div>
            </div>

            <div role="tablist" aria-label="Filter team by year" className="flex gap-px bg-[#006699]/15 p-px self-start lg:self-auto">
              {years.map((y) => {
                const on = selectedYear === y;
                return (
                  <button
                    key={y}
                    role="tab"
                    aria-selected={on}
                    onClick={() => setSelectedYear(y)}
                    className={`relative px-5 sm:px-6 py-3 text-sm font-bold tabular-nums transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#006699] focus-visible:ring-offset-2 ${
                      on ? "text-white" : "bg-white text-[#006699] hover:bg-[#006699]/5"
                    }`}
                  >
                    {on && (
                      <motion.span
                        layoutId="team-year"
                        className="absolute inset-0 bg-[#00334d]"
                        transition={{ type: "spring", stiffness: 420, damping: 36 }}
                      />
                    )}
                    <span className="relative">{y}</span>
                  </button>
                );
              })}
            </div>
          </div>

          {/* members (remounts on year change so the entrance replays) */}
          <motion.div key={selectedYear} variants={list} initial="hidden" animate="visible">
            {/* always 2 columns on phone, smaller gap = bigger cards */}
            <div className="flex flex-wrap justify-center gap-2.5 sm:gap-8">
              {members.map((member, i) =>
                member.position === "Counselor" ? null : (
                  <div
                    key={`${selectedYear}-${i}`}
                    className="w-[calc(50%-0.3125rem)] sm:w-[calc(50%-1rem)] lg:w-[calc(33.333%-1.34rem)] xl:w-[calc(25%-1.5rem)]"
                  >
                    <Card member={member} index={i} onOpen={() => setOpenIndex(i)} />
                  </div>
                )
              )}
            </div>

            {members.map((member, i) =>
              member.position === "Counselor" ? (
                <div key={`${selectedYear}-wide-${i}`} className="mt-6 sm:mt-12">
                  <WideCard member={member} index={i} onOpen={() => setOpenIndex(i)} />
                </div>
              ) : null
            )}
          </motion.div>
        </div>

        <AnimatePresence>
          {openIndex !== null && members[openIndex] && (
            <TeamModal
              key="team-modal"
              member={members[openIndex]}
              index={openIndex}
              total={members.length}
              year={selectedYear}
              onClose={close}
              onPrev={onPrev}
              onNext={onNext}
            />
          )}
        </AnimatePresence>
      </section>
    </MotionConfig>
  );
}